module.exports = __webpack_public_path__ + "static/media/onboard-content2.3d28ef57.png";